
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateCollaboratorContracts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contracts"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CollaboratorContractInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"updateCollaborator"},"name":{"kind":"Name","value":"collaboratorUpdateCollaborator"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"uuid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uuid"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"contracts"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contracts"}}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contracts"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"noContract"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"company"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"companyCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"buildingCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contractType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"specificContract"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cddRecourseReason"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"endDateCdd"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"departureReasonCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"exitReason"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"jobCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"jobCategory"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"job"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"managerRegistrationNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sex"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"workUnit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contractStartDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contractEndDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"establishmentName"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":554}};
    doc.loc.source = {"body":"mutation updateCollaboratorContracts(\n\t$uuid: ID!\n\t$contracts: [CollaboratorContractInput]\n\t\n) {\n\tupdateCollaborator: collaboratorUpdateCollaborator(\n\t\tinput: {\n\t\t\tuuid: $uuid\n\t\t\tcontracts: $contracts\n\t\t}\n\t) {\n\t\tuuid\n\t\tcontracts{\n\t\t\tnoContract\n\t\t\tcompany\n\t\t\tcompanyCode\n\t\t\tbuildingCode\n\t\t\tcontractType\n\t\t\tspecificContract\n\t\t\tcddRecourseReason\n\t\t\tendDateCdd\n\t\t\tstatus\n\t\t\tdepartureReasonCode\n\t\t\texitReason\n\t\t\tjobCode\n\t\t\tjobCategory\n\t\t\tjob\n\t\t\tmanagerRegistrationNumber\n\t\t\tsex\n\t\t\tworkUnit\n\t\t\tcontractStartDate\n\t\t\tcontractEndDate\n\t\t\testablishmentName\n\t\t}\n\t}\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["updateCollaboratorContracts"] = oneQuery(doc, "updateCollaboratorContracts");
        
